// eslint-disable-next-line import/no-extraneous-dependencies
import { ca } from '@cian/analytics';

import { IProduct } from '../../../types/analytics';

export function trackShowWarning(product: IProduct) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ct_informer',
    action: 'show',
    label: 'popup',
    products: [product],
  });
}
